import { render, staticRenderFns } from "./FinalLabContainer.vue?vue&type=template&id=d38f1b06"
import script from "./FinalLabContainer.vue?vue&type=script&lang=js"
export * from "./FinalLabContainer.vue?vue&type=script&lang=js"
import style0 from "./FinalLabContainer.vue?vue&type=style&index=0&id=d38f1b06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports